import { profilesStore } from './profiles-store';
export const {
  setActiveProfile,
  subscribe,
  subscribeTo,
  refetchProfiles,
  unsubscribeAll,
  batch,
  getState,
  destroy,
  resetState,
  setState,
  setupTabSync,
} = profilesStore;
